<p>transit-do-payments-submit works!</p>
